import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { baseUrlParser, commonShowAlert } from 'lib';
import {
    getDefaultHeaders,
    instance as axiosInstance,
    useAlert,
    useAuth,
    withHeaders,
} from '../core';

const getQueryData = async (
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const baseUrl: string = baseUrlParser(process.env.REACT_APP_BASE_API_URL);
    const serverInfoUrl = baseUrl + '/management/info';

    const response = await axiosInstance().get(
        serverInfoUrl,
        withHeaders(headers)
    );

    return response.data;
};

export const useServerInfo = (): UseQueryResult<any, unknown> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useQuery('swagger-config', async () => getQueryData(getToken()), {
        retry: false,
        refetchOnWindowFocus: false,
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ??
                'Unable retrieve server health information';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
